<template>
    <div>
        <el-container>
            <el-main>
                用户列表
                <el-row :gutter="10" style="margin-top:10px; align: center;">
                    <el-col :span="4">
                        <el-input
                          placeholder="请输入搜索内容"
                          v-model="q"
                          clearable>
                        </el-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" icon="el-icon-search" @click="handleUserSearch()">搜索</el-button>
                    </el-col>
                </el-row>
                <el-table stripe :data="tableData" border style="width: 100%; margin-top:10px;"  size="mini">
                    <el-table-column align="center" fixed prop="id" label="#" width="50">
                    </el-table-column>
                    <el-table-column align="center" fixed prop="username" label="用户名" width="100">
                    </el-table-column>
                    <el-table-column align="center" fixed prop="name" label="姓名" width="100">
                    </el-table-column>
                    <el-table-column align="center" fixed prop="phone" label="电话" width="110">
                    </el-table-column>
                    <el-table-column align="center" fixed prop="email" label="Email" width="110">
                    </el-table-column>
                    <el-table-column align="center" prop="country" label="国家">
                    </el-table-column>
                    <el-table-column align="center" prop="active" label="是否可用" :formatter="boolFormatter">
                    </el-table-column>
                    <el-table-column align="center" prop="createDate" label="创建时间">
                    </el-table-column>
                    <el-table-column align="center" prop="remark" label="备注" width="120">
                    </el-table-column>
                    <el-table-column align="center" fixed="right" label="操作">
                        <template slot-scope="scope">
                            <!-- <el-button @click="handleOperaClick(scope.row, 1)" type="text" icon="el-icon-info"></el-button> -->
                            <el-button v-if="hasPerm('admin_account_update')" @click="handleOperaClick(scope.row, 2)" type="text" icon="el-icon-edit"></el-button>
                            <el-button v-if="hasPerm('admin_account_delete')" @click="handleOperaClick(scope.row, 3)" type="text" icon="el-icon-delete"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 40, 60, 80, 100]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
                <el-dialog title="温馨提示" :visible.sync="deleteDialogVisible" width="30%">
                    <span>确定删除该条记录？</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteDialogVisible = false">取 消</el-button>
                        <el-button type="primary" @click="deleteDialogConfirm">确 定</el-button>
                    </span>
                </el-dialog>
            </el-main>
        </el-container>
    </div>
</template>
<style>
</style>
<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'

export default {
    name: 'adminUser',
    data() {
        return {
            q: '',
            deleteDialogVisible: false,
            currentOperaRow: null,
            currentPage: 1,
            total: 0,
            limit: 20,
            tableData: []
        }
    },
    methods: {
        boolFormatter(row, column, cellValue, index) {
            return cellValue + ''
        },
        handleOperaClick(rowData, action) {
            console.log('rowData', rowData, " action", action)
            this.currentOperaRow = rowData
            if(action==2){
                this.$router.push({
                    path: `/adminUser/${rowData.id}/edit`
                })
            }else if (action == 3) {
                this.deleteDialogVisible = true
            }
        },
        deleteDialogConfirm() {
            this.deleteDialogVisible = false
            if (this.currentOperaRow != null) {
                let userId = this.currentOperaRow.id

                this.$api.deleteAdminUser(userId).then(resp => {
                    const index = this.tableData.findIndex(item => item.id===userId)
                    if (index > -1) {
                        this.tableData.splice(index, 1)
                        this.$notify({
                            title: '成功',
                            message: '删除用户成功',
                            type: 'success'
                        });
                    }

                })
            }
        },
        handleSizeChange(val) {
            this.limit = val
            this.getAdminUser()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getAdminUser()
        },
        getAdminUser() {
            let params = {
                page: this.currentPage,
                limit: this.limit
            }
            if (this.q) {
                params['q'] = this.q
            }

            this.$api.api.getUsers(params).then(
                resp => {
                    this.tableData = resp.data
                    this.currentPage = resp.page.page
                    this.total = resp.page.total
                })
        },
        handleUserSearch() {
            this.getAdminUser()
        }
    },
    mounted() {
        this.getAdminUser()
    },
    computed: {
        ...mapGetters([
          'hasPerm'
        ])
    },
    components: {}
}
</script>


// WEBPACK FOOTER //
// src/views/admin/user/list.vue